module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/cover_generator_manual/top-db9f95f5aefc6eee1ed5445c6cfa42bb.png";